<script lang="ts" setup>
  import { ref } from 'vue'
  import AppSkeletonLoader from '@/components/AppSkeletonLoader.vue'

  const isFallbackStateActive = ref(false)

  const refLoadingIndicator = ref<typeof AppSkeletonLoader | null>(null)

  watch([isFallbackStateActive, refLoadingIndicator], () => {
    if (isFallbackStateActive.value && refLoadingIndicator.value)
      refLoadingIndicator.value.fallbackHandle()

    if (!isFallbackStateActive.value && refLoadingIndicator.value)
      refLoadingIndicator.value.resolveHandle()
  }, { immediate: true })
</script>

<template>
  <app-skeleton-loader ref="refLoadingIndicator" />

  <app-header />

  <v-main>
    <router-view #="{Component}">
      <suspense
        :timeout="0"
        @fallback="isFallbackStateActive = true"
        @resolve="isFallbackStateActive = false"
      >
        <v-fade-transition hide-on-leave>
          <Component :is="Component" />
        </v-fade-transition>
      </suspense>
    </router-view>
  </v-main>
  <footer>
    <payment-dialog />
  </footer>
</template>

<style lang="sass" scoped>

</style>
